// extracted by mini-css-extract-plugin
export default {"btn":"buttonColor_btn__x4kXL"};